// Configuration - Using Liquid variables  
const WEBHOOK_URL = webhookUrl; 
const SESSION_KEY = '{{ settings.session_key | default: "debutify_chat_session" }}';  
const MESSAGES_KEY = '{{ settings.messages_key | default: "debutify_chat_messages" }}';  
const WELCOME_MESSAGE = '{{"👋 Welcome to Sanctus Brewing Assistant! How can I assist you today?" }}';  
  
// Global variables  
let sessionId = '';  
let messages = [];  
let chatbotOpen = false;  
  
// Toggle chatbot visibility  
function toggleDebutifyChatbot() {  
  const container = document.getElementById('dbtfyChatbotContainer');  
  const icon = document.getElementById('dbtfy-chatbot-icon');  
  
  if (chatbotOpen) {  
    container.classList.remove('open');  
    icon.textContent = '💬';  
    chatbotOpen = false;  
  
    if (window.innerWidth <= 480) {  
      document.body.classList.remove('chatbot-open');  
    }  
  } else {  
    container.classList.add('open');  
    icon.textContent = '✕';  
    chatbotOpen = true;  
  
    if (window.innerWidth <= 480) {  
      document.body.classList.add('chatbot-open');  
    }  
  
    if (!sessionId) {  
      initChat();  
    }  
  
    setTimeout(() => {  
      const chatInput = document.getElementById('chatInput');  
      if (chatInput) chatInput.focus();  
    }, 300);  
  }  
}  
  
// Handle Enter key press  
function handleKeyDown(event) {  
  if (event.key === 'Enter' && !event.shiftKey) {  
    event.preventDefault();  
    sendMessage();  
  }  
}  
  
// Adjust textarea height  
function adjustTextareaHeight(textarea) {  
  textarea.style.height = 'auto';  
  const newHeight = Math.min(textarea.scrollHeight, 100);  
  textarea.style.height = newHeight + 'px';  
}  
  
// Start new chat  
function startNewChat() {  
  if (confirm('Are you sure you want to start a new chat? This will clear your current conversation.')) {  
    messages = [];  
    localStorage.removeItem(MESSAGES_KEY);  
    sessionId = generateSessionId();  
    localStorage.setItem(SESSION_KEY, sessionId);  
    const messagesContainer = document.getElementById('chatMessages');  
    messagesContainer.innerHTML = '<div class="welcome-message">' + WELCOME_MESSAGE + '</div>';  
  
    const chatInput = document.getElementById('chatInput');  
    if (chatInput) chatInput.focus();  
  }  
}  
  
// Send message to N8N webhook  
async function sendMessage() {  
  const input = document.getElementById('chatInput');  
  const message = input.value.trim();  
  
  if (!message) return;  
  
  input.value = '';  
  adjustTextareaHeight(input);  
  toggleSendButton(false);  
  addMessage(message, true);  
  showTypingIndicator(true);  
  
  try {  
    const response = await fetch(WEBHOOK_URL, {  
      method: 'POST',  
      headers: {  
        'Content-Type': 'application/json',  
      },  
      body: JSON.stringify({  
        sessionId: sessionId,  
        action: "getOMessage",  
        chatInput: message  
      })  
    });  
    if (!response.ok) {  
      throw new Error(`HTTP error! status: ${response.status}`);  
    }  
    const data = await response.json();  
  
    console.log('N8N Response:', data);  
  
    let aiResponse;  
    if (Array.isArray(data) && data.length > 0) {  
      aiResponse = data[0].output || data[0].response || data[0].message || data[0].chatOutput || 'Sorry, I encountered an error processing your request.';  
    } else {  
      aiResponse = data.output || data.response || data.message || data.chatOutput || 'Sorry, I encountered an error processing your request.';  
    }  
    addMessage(aiResponse, false);  
  } catch (error) {  
    console.error('Error sending message:', error);  
    addMessage('Sorry, I\'m having trouble connecting right now. Please try again in a moment.', false);  
  } finally {  
    showTypingIndicator(false);  
    toggleSendButton(true);  
    input.focus();  
  }  
}  
  
// Initialize chat  
function initChat() {  
  sessionId = localStorage.getItem(SESSION_KEY) || generateSessionId();  
  localStorage.setItem(SESSION_KEY, sessionId);  
  const savedMessages = localStorage.getItem(MESSAGES_KEY);  
  if (savedMessages) {  
    messages = JSON.parse(savedMessages);  
    renderMessages();  
  }  
}  
  
// Generate unique session ID  
function generateSessionId() {  
  return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);  
}  
  
// Save messages to localStorage  
function saveMessages() {  
  localStorage.setItem(MESSAGES_KEY, JSON.stringify(messages));  
}  
  
// Add message to chat  
function addMessage(text, isUser = false) {  
  const message = {  
    text: text,  
    isUser: isUser,  
    timestamp: new Date().toISOString()  
  };  
  messages.push(message);  
  saveMessages();  
  renderMessage(message);  
  scrollToBottom();  
}  
  
// Render single message  
function renderMessage(message) {  
  const messagesContainer = document.getElementById('chatMessages');  
  const messageDiv = document.createElement('div');  
  messageDiv.className = `message ${message.isUser ? 'user' : 'ai'}`;  
  
  const iconDiv = document.createElement('div');  
  iconDiv.className = `message-icon ${message.isUser ? 'user-icon' : 'ai-icon'}`;  
  iconDiv.innerHTML = message.isUser ? '👤' : '🤖';  
  
  const contentDiv = document.createElement('div');  
  contentDiv.className = 'message-content';  
  
  const processedText = processLinks(message.text);  
  contentDiv.innerHTML = processedText;  
  
  if (message.isUser) {  
    messageDiv.appendChild(contentDiv);  
    messageDiv.appendChild(iconDiv);  
  } else {  
    messageDiv.appendChild(iconDiv);  
    messageDiv.appendChild(contentDiv);  
  }  
  
  messagesContainer.appendChild(messageDiv);  
}  
  
// Process text to make links user-friendly  
function processLinks(text) {  
  const urlRegex = /(https?:\/\/[^\s]+)/g;  
  return text.replace(urlRegex, (url) => {  
    let displayUrl = url.replace(/^https?:\/\//, '');  
    if (displayUrl.length > 40) {  
      displayUrl = displayUrl.substring(0, 40) + '...';  
    }  
    return `<a href="${url}" target="_blank" rel="noopener noreferrer">${displayUrl}</a>`;  
  });  
}  
  
// Render all messages  
function renderMessages() {  
  const messagesContainer = document.getElementById('chatMessages');  
  if (messages.length > 0) {  
    messagesContainer.innerHTML = '';  
  }  
  messages.forEach(renderMessage);  
  scrollToBottom();  
}  
  
// Show/hide typing indicator  
function showTypingIndicator(show) {  
  const indicator = document.getElementById('typingIndicator');  
  if (indicator) {  
    if (show) {  
      indicator.classList.add('show');  
      scrollToBottom();  
    } else {  
      indicator.classList.remove('show');  
    }  
  }  
}  
  
// Toggle send button state  
function toggleSendButton(enabled) {  
  const button = document.getElementById('sendButton');  
  if (button) {  
    button.disabled = !enabled;  
  }  
}  
  
// Scroll to bottom of messages  
function scrollToBottom() {  
  const messagesContainer = document.getElementById('chatMessages');  
  if (messagesContainer) {  
    messagesContainer.scrollTop = messagesContainer.scrollHeight;  
  }  
}  